module.exports = __webpack_public_path__ + "static/media/bancard.41d9e8ea.svg";